import React, { useState } from 'react';
import { StepContainer, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';

export const Step16_Renda: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const incomeOptions = [
    { label: 'Até R$ 1.000', value: 'Até R$ 1.000' },
    { label: 'R$ 1.000 - R$ 2.000', value: 'R$ 1.000 - R$ 2.000' },
    { label: 'R$ 2.000 - R$ 3.000', value: 'R$ 2.000 - R$ 3.000' },
    { label: 'R$ 3.000 - R$ 5.000', value: 'R$ 3.000 - R$ 5.000' },
    { label: 'R$ 5.000 - R$ 10.000', value: 'R$ 5.000 - R$ 10.000' },
    { label: 'Acima de R$ 10.000', value: 'Acima de R$ 10.000' },
  ];

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.income) newErrors.income = 'Faixa de renda é obrigatória';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ income: data.income as string });
  };

  const handleFieldChange = (fieldName: keyof FormData, value: string) => {
    updateField(fieldName, value);
    if (errors[fieldName]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="Qual sua renda pessoal mensal?">
      <div>
        <ChoiceButtons
          options={incomeOptions}
          selected={data.income || ''}
          onSelect={(value) => handleFieldChange('income', value)}
        />
        {errors.income && (
          <p className="text-red-600 text-sm mt-2">{errors.income}</p>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step16_Renda;
